!customElements.get("op-plp-product-card") && customElements.define("op-plp-product-card", class extends OpAlgoliaUtilities {
    connectedCallback () {
        this.groupKey = this.dataset.groupKey;
        this.handle = this.dataset.pdHandle;
        this.productId = this.dataset.pdId;
        this.hits = [];
        this.productAnchor = this.closest(".op-algolia-product-card")?.querySelector("[data-product-href]");
        this.template = this.querySelector("template");
        this.templateName = this.closest("[data-template-name]")?.dataset.templateName;
        this.ungrouped = this.checkUngrouped();
        this.shopRoot = window.Shopify?.routes?.root || "/";
        this.sliderComponent = null;
        this.currentPage = 1;
        this.badgeTemplates = new Map();
        this.plpHandle = window.collection?.plp_handle || "all-products";

        if (this.ungrouped) {
            this.renderStaticThumb();
        } else if (this.groupKey) {
            this.loadProductGroup();
        }

        document.addEventListener("plp:groups-loaded", this.handleGroupsLoaded);
    }

    disconnectedCallback () {
        this.removeSliderComponent();
        document.removeEventListener("plp:groups-loaded", this.handleGroupsLoaded);
    }


    checkUngrouped(){
        if(this.templateName === "search" || window.collection.not_grouped == true || this.closest("op-algolia-header-search")){
            return true;
        }
        return false;
    }

    createProductSlide (hit, index, slideTemplate, productUrl, cardIndex) {        
        const slide = slideTemplate.cloneNode(true);
        const lazyLoad = cardIndex >= 3 || index > 0;

        slide.id = `${slideTemplate.id}-${index + 1}`;
        slide.dataset.pdSlide = hit.objectID;

        slide.querySelectorAll("[data-pd-url]").forEach(el => {
            el.href = productUrl;
            el.dataset.pdUrl = productUrl;
            el.addEventListener("click", () => this.saveSessionHits());
        });

        this.getProductInfo(productUrl).then(data => {
            const product = data?.product;
            const featuredImage = product?.featured_image || hit.image;
            const hoverImage = product?.images?.length > 1 ? product.images[1] : featuredImage;
            const imgWidth = this.isDesktop() ? 800 : 400;

            if(this.dataset.nontransactional !== "true")
                slide.toggleAttribute("data-unavailable", !product?.available);

            if (!featuredImage) {
                console.warn("Featured image not found for hit:", hit);
                return;
            }
            
            slide.querySelectorAll("[data-pd-image-wrapper]").forEach(el => {
                const img = el.querySelector("img") || document.createElement("img");
                img.src = this.formatImageUrl(featuredImage, imgWidth);
                img.alt = product?.alt_image || hit.title;
                img.title = product?.title_image || hit.title

                if (lazyLoad) {
                    img.loading = "lazy";
                }
    
                el.appendChild(img);
            });
            
            slide.querySelectorAll("[data-pd-image-hover-wrapper]").forEach(el => {
                const img = el.querySelector("img") || document.createElement("img");
                img.src = this.formatImageUrl(hoverImage, imgWidth);
                img.alt = product?.alt_hover || hit.title;
                img.title = product?.title_hover || hit.title;
                
                if (lazyLoad) {
                    img.loading = "lazy";
                }
    
                el.appendChild(img);
            });

            if (data?.template) {
                this.badgeTemplates.set(productUrl, data.template);
            }

            if (index === 0) {
                this.onProductSwipe(productUrl);
            }
        });
        
        return slide;
    }

    createProductThumbnail (hit, index, thumbTemplate, productUrl) {
        const thumb = thumbTemplate.cloneNode(true);
        const thumbImg = thumb.querySelector("img") || document.createElement("img");

        thumb.id = `${thumbTemplate.id}-${index + 1}`;
        thumb.dataset.selected = index === 0;
        thumb.dataset.href = productUrl;
        thumb.dataset.pdThumb = hit.objectID;
        thumb.dataset.index = index;

        if (hit.image) {
            thumbImg.src = this.formatImageUrl(hit.image, 200, 100);
            thumbImg.alt = hit.title;
            thumbImg.loading = "lazy"
            thumbImg.width = 100;
            thumbImg.height = 50;
            thumb.appendChild(thumbImg);
        }

        return thumb;
    }

    formatImageUrl (url, width, height) {
        const parsedUrl = url ? new URL(url, window.location.origin) : null;

        if (!parsedUrl) {
            console.error("Invalid URL:", url);
            return url;
        }

        if (width) {
            parsedUrl.searchParams.set("width", width);
        }

        if (height) {
            parsedUrl.searchParams.set("height", height);
        }

        return parsedUrl.toString();
    }

    getListItemIndex () {
        const li = this.closest("li");
        return li ? Array.prototype.indexOf.call(li.parentNode.children, li) : -1;
    }

    async getProductInfo (productUrl) {
        try {
            const response = await fetch(`${productUrl}?view=op-info-badge`);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const text = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, 'text/html');
            const jsonData = doc.querySelector('script[type="application/json"]')?.textContent?.trim();
            
            return {
                product: jsonData ? JSON.parse(jsonData) : null,
                template: doc.querySelector("template")
            }
        }
        catch (error) {
            console.error("Error fetching product info:", error);
            return null;
        }
    }

    handleGroupsLoaded = (event) => {
        const groups = event.details;

        if (Array.isArray(groups) && groups.some(g => g.xGroupKey === this.groupKey)) {
            this.loadProductGroup();
        }
    }

    isDesktop () {
        return window.matchMedia('(min-width: 1024px)').matches;
    }

    loadProductGroup () {
        try {
            const lastGroups = JSON.parse(sessionStorage.getItem("lastPLPGroups"));
            const group = Array.isArray(lastGroups) ? lastGroups.find(g => g.xGroupKey === this.groupKey) : null;
            const hits = group?.hits;

            if (Array.isArray(hits) && hits.length > 0) {
                this.hits = hits;
                this.removeSliderComponent();
                this.renderThumb();
            }
        }
        catch (error) {
            console.error("Error parsing lastGroupItem session storage:", error);
        }

        if (this.hits.length === 0) {
            this.removeSliderComponent();
            this.renderStaticThumb();
        }
    }

    onProductSwipe (productUrl) {
        const template = this.badgeTemplates.get(productUrl);
        const content = template?.content?.cloneNode(true);

        if (content) {
            this.updateBadge(content);
            this.updateDNPrice(content);
            this.updateCaption(content);
        }

        if (this.productAnchor && productUrl) {
            this.productAnchor.href = productUrl;
        }
    }

    renderStaticThumb () {
        const clone = this.template?.content?.cloneNode(true);
        const sliderComponent = clone?.querySelector("op-slider-component");

        if (!sliderComponent) {
            console.error("Slider component not found in template.");
            return;
        }

        const slider = sliderComponent.querySelector("[data-slider");
        const slide = sliderComponent.querySelector("[data-pd-slide]");
        const slideClone = slide.cloneNode(true);
        const thumb = sliderComponent.querySelector("[data-pd-thumb]");
        const thumbContainer = sliderComponent.querySelector("[data-thumbnails]");
        const controller = sliderComponent.querySelector("[data-controller]");
        const productUrl = `${this.shopRoot}products/${this.handle}`;
        const lazyLoad = this.getListItemIndex() >= 3;

        if (controller && thumbContainer) {
            this.ungrouped ? controller.style.display = "none" : controller.style.visibility = 'hidden';
            thumbContainer.style.visibility = 'hidden';
        }

        this.getProductInfo(productUrl).then(data => {
            const product = data?.product;
            const featuredImage = product?.featured_image;
            const hoverImage = product?.images?.length > 1 ? product.images[1] : featuredImage;
            const productTitle = product?.title || "";
            const imgWidth = this.isDesktop() ? 800 : 400;

            slideClone.id = `${slide.id}-1`;
            slideClone.dataset.pdSlide = this.productId;
            if(this.dataset.nontransactional !== "true")
                slideClone.toggleAttribute("data-unavailable", !product?.available);

            if (featuredImage) {
                slideClone.querySelectorAll("[data-pd-image-wrapper]").forEach(el => {
                    const img = el.querySelector("img") || document.createElement("img");
                    img.src = this.formatImageUrl(featuredImage, imgWidth);
                    img.alt = product?.alt_image || productTitle;
                    img.title = product?.title_image || productTitle;

                    if (lazyLoad) {
                        img.loading = "lazy";
                    }
        
                    el.appendChild(img);
                });
                
                slideClone.querySelectorAll("[data-pd-image-hover-wrapper]").forEach(el => {
                    const img = el.querySelector("img") || document.createElement("img");
                    img.src = this.formatImageUrl(hoverImage, imgWidth);
                    img.alt = product?.alt_hover || productTitle;
                    img.title = product?.title_hover || productTitle;
                    
                    if (lazyLoad) {
                        img.loading = "lazy";
                    }
        
                    el.appendChild(img);
                });
            }

            slideClone.querySelectorAll("[data-pd-url]").forEach(el => {
                el.href = productUrl;
                el.dataset.pdUrl = productUrl;
            });

            if (!this.ungrouped) {
                const hit = {
                    image: featuredImage,
                    title: productTitle
                }

                const thumbClone = this.createProductThumbnail(hit, 0, thumb, productUrl);
                thumbContainer.appendChild(thumbClone);
            }

            slider.appendChild(slideClone);
            slide.remove();
            thumb.remove();
            if(!this.querySelector("op-slider-component") )
                this.appendChild(sliderComponent);
            this.sliderComponent = sliderComponent;
        });
    }

    renderThumb () {
        const clone = this.template?.content?.cloneNode(true);
        const sliderComponent = clone?.querySelector("op-slider-component");

        if (!sliderComponent) {
            console.error("Slider component not found in template.");
            return;
        }

        const slider = sliderComponent.querySelector("[data-slider");
        const slide = sliderComponent.querySelector("[data-pd-slide]");
        const thumbContainer = sliderComponent.querySelector("[data-thumbnails]");
        const thumb = sliderComponent.querySelector("[data-pd-thumb]");
        const countDisplay = sliderComponent.querySelector("[data-slide-count]");
        const controller = sliderComponent.querySelector("[data-controller]");
        const cardIndex = this.getListItemIndex();

        let collectionHits = this.hits.filter(hit => {
            const collections = hit.collections;
            return Array.isArray(collections) && collections.includes(this.plpHandle);
        });

        if (collectionHits.length === 0) {
            collectionHits = this.hits;
            console.warn(`No hits found for collection handle: ${this.plpHandle}. Displaying all hits.`);
        }

        collectionHits.forEach((hit, index) => {
            const productUrl = `${this.shopRoot}products/${hit.handle}`;
            const productSlide = this.createProductSlide(hit, index, slide, productUrl, cardIndex);
            const thumbClone = this.createProductThumbnail(hit, index, thumb, productUrl);

            slider.appendChild(productSlide);
            thumbContainer.appendChild(thumbClone);
        });

        if(collectionHits.length === 1) {
            controller.style.visibility = 'hidden';
            thumbContainer.style.visibility = 'hidden';
        } else if (collectionHits.length <= 4) {
            thumbContainer.style.justifyContent = 'center';
        }

        if (countDisplay) {
            countDisplay.textContent = collectionHits.length;
        }

        slide.remove();
        thumb.remove();
        this.appendChild(sliderComponent);

        sliderComponent.addEventListener("slideChanged", this.slideChangedHandler);

        this.sliderComponent = sliderComponent;
    }

    removeSliderComponent () {
        if (this.sliderComponent) {
            this.sliderComponent.removeEventListener("slideChanged", this.slideChangedHandler);
            this.sliderComponent.remove();
        }
    }

    saveSessionHits () {
        sessionStorage.setItem("lastGroupItem", JSON.stringify({
            xGroupKey: this.groupKey,
            hits: this.hits
        }));
    }

    slideChangedHandler = (event) => {
        const pageN = event.detail?.currentPage || 1;
        const productHref = event.detail?.currentThumbnail?.dataset?.href;

        if (!productHref || pageN === this.currentPage) {
            return;
        }

        this.currentPage = pageN;
        this.onProductSwipe(productHref);
    }

    updateBadge (templateContent) {
        const badgeWrapper = this.querySelector("[data-badge-wrapper]");

        if (badgeWrapper && templateContent) {
            badgeWrapper.replaceWith(templateContent.querySelector("[data-badge-wrapper]") || badgeWrapper);
        }
    }

    updateDNPrice (templateContent) {
        const dnElement = this.closest(".op-algolia-product-card")?.querySelector("op-discount-ninja-price");
        const priceEl = dnElement.querySelector("[data-la-dn-price]");
        const newDnEl = templateContent?.querySelector("op-discount-ninja-price");

        if (newDnEl && dnElement) {
            priceEl?.replaceWith(newDnEl?.querySelector("[data-la-dn-price]") || priceEl);

            for (let attr in newDnEl.dataset) {
                dnElement.dataset[attr] = newDnEl.dataset[attr];
            }

            document.dispatchEvent(new CustomEvent('la:dn:collection:updated'));
        }
    }

    updateCaption (templateContent) {
        const card = this.closest(".op-algolia-product-card");
        const caption = card?.querySelector("[data-caption]");
        const status = card?.querySelector("[data-prod-status]");
        const newCaption = templateContent?.querySelector("[data-caption]");
        const newStatus = templateContent?.querySelector("[data-prod-status]");

        if (caption && newCaption) {
            caption.replaceWith(newCaption);
        }

        if (status && newStatus) {
            status.replaceWith(newStatus);
        }
    }
});